import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "@/redux/store";
import { closeMobileMenu } from "@/slices/sidebarSlice";
import DesktopSideMenu from "./DesktopSideMenu";
import MobileSideMenu from "./MobileSideMenu";

interface SideMenuProps {
    isMobile: boolean;
}

const SideMenu: React.FC<SideMenuProps> = ({ isMobile }) => {
    const dispatch = useDispatch();
    const isMobileMenuVisible = useSelector((state: RootState) => state.sidebar.isMobileMenuVisible);

    return (
        <>
            {isMobile ? (
                <>
                    {/* Mobile Sidebar */}
                    <MobileSideMenu
                        isVisible={isMobileMenuVisible}
                        onClose={() => dispatch(closeMobileMenu())}
                    />
                </>
            ) : (
                <DesktopSideMenu />
            )}
        </>
    );
};

export default SideMenu;
